
export const en = {
  common: {
    close: 'Close',
    copy: 'Copy',
    copied: 'Copied',
    news: 'News',
    more: 'More',
    success: 'Success',
    failed: 'Failed',
    page: 'Page',
    of: 'of',
    loading: 'Loading...',
    error: 'Error',
    search: 'Search',
    reset: 'Reset',
    filter: 'Filter',
    details: 'Details',
    no_results: 'No results found',
    no_description: 'No description available',
    back: 'Back',
    deselect_all: 'Deselect All',
    select_all: 'Select All',
    yes: 'Yes',
    no: 'No',
  },
  navbar: {
    news: 'News',
    leaks: 'Leaks',
    cve: 'CVE',
    ransomware: 'Ransomware',
    eol: 'EOL',
    releases: 'Releases',
    dashboard: 'Dashboard',
    scan: 'Scan',
  },
  cities: {
    "Los Angeles": "Los Angeles",
    "Zurich": "Zurich",
    "Viana": "Viana",
    "Moscow": "Moscow",
    "Falkenstein": "Falkenstein",
    "Vienna": "Vienna",
    "Sofia": "Sofia",
    "Paris": "Paris",
    "Amsterdam": "Amsterdam",
    "London": "London",
    "London, UK": "London, UK",
    "Singapore": "Singapore",
    "New York": "New York",
    "Dallas": "Dallas",
    "Miami": "Miami",
    "Frankfurt": "Frankfurt",
    "Warsaw": "Warsaw",
    "Bengaluru": "Bengaluru",
    "Delhi": "Delhi",
    "Hyderabad": "Hyderabad",
    "Kolkata": "Kolkata",
    "Mumbai": "Mumbai",
    "Jakarta": "Jakarta",
    "Esfahan": "Esfahan",
    "Karaj": "Karaj",
    "Mashhad": "Mashhad",
    "Shiraz": "Shiraz",
    "Tehran": "Tehran",
    "Netanya": "Netanya",
    "Tel Aviv": "Tel Aviv",
    "Milan": "Milan",
    "Tokyo": "Tokyo",
    "Sao Paulo": "Sao Paulo",
    "Vancouver": "Vancouver",
    "Ceske Budejovice": "Ceske Budejovice",
    "Helsinki": "Helsinki",
    "Roubaix": "Roubaix",
    "Nuremberg": "Nuremberg",
    "Hong Kong": "Hong Kong",
    "Nyiregyhaza": "Nyiregyhaza",
    "Seoul": "Seoul",
    "Karaganda": "Karaganda",
    "Vilnius": "Vilnius",
    "Chisinau": "Chisinau",
    "Meppel": "Meppel",
    "Poznan": "Poznan",
    "Belgrade": "Belgrade",
    "Saint Petersburg": "Saint Petersburg",
    "Ekaterinburg": "Ekaterinburg",
    "Tallberg": "Tallberg",
    "Maribor": "Maribor",
    "Gebze": "Gebze",
    "Khmelnytskyi": "Khmelnytskyi",
    "Kyiv": "Kyiv",
    "SpaceX Starlink": "SpaceX Starlink",
    "Coventry": "Coventry",
    "Atlanta": "Atlanta",
    "Ho Chi Minh City": "Ho Chi Minh City",
    "C.Budejovice": "C.Budejovice",
    "Barcelona": "Barcelona",
    "Madrid": "Madrid"
  },

  index: {
    title: 'CyberMonit - Stay up-to-date with cybersecurity threats',
    description: 'CyberMonit is a platform for monitoring and analyzing cybersecurity threats. We collect data from various sources to provide you with the most up-to-date information about leaks, vulnerabilities, ransomware, and software end-of-life.',
    latest_news: 'Latest News',
    leaks: 'Leaks',
    cve: 'CVE',
    ransomware: 'Ransomware',
    eol: 'EOL',
  },
  news: {
    title: 'Latest News',
    sources: 'News Sources',
    loading: 'Loading news...',
    error: 'Failed to load news',
    readMore: 'Read more',
    page: 'Page',
    of: 'of',
    pageTitle: 'Latest Cybersecurity News',
    read_more: 'Read more',
  },
  leaks: {
    title: 'Latest Data Leaks',
    subtitle: 'Stay informed about the latest data leaks and breaches. Our database is constantly updated with the most recent information.',
    searchPlaceholder: 'Search leaks...',
    noLeaks: 'No leaks found.',
    domain: 'Domain',
    no_domain: 'Unknown Source',
    dataTypes: 'Data Types',
    details: 'View Details',
    breach_stats: 'Breach Statistics',
    records: 'Records',
    data_types: 'Data Types',
    description: 'Description',
    close: 'Close',
    loading: 'Loading leaks...',
    error: 'Failed to load leaks',
    searchResults: '{count} results found',
    noResults: 'No leaks found matching your criteria',
    resetFilters: 'Reset filters',
    pageTitle: 'Data Breach Database',
    verified_leak: 'VERIFIED LEAK',
    verified_source: 'Verified Source',
  },
  cve: {
    title: 'CVE Vulnerabilities',
    subtitle: 'Search for Common Vulnerabilities and Exposures (CVE) information',
    searchPlaceholder: 'Search CVE (e.g., CVE-2023-4863)',
    clearSearch: 'Clear search',
    searching_progress: 'Searching...',
    noSearchResults: 'No CVEs found matching your search criteria',
    searchResults: '{count} CVEs found',
    year_selector: 'Year',
    year_selector_description: 'Select CVE year',
    filter: 'Severity Filter',
    'filter.critical': 'Critical',
    'filter.high': 'High',
    'filter.medium': 'Medium',
    'filter.low': 'Low',
    current_year: 'Current Year',
    details: 'View Details',
    score: 'Score',
    close: 'Close',
    search_all_years: 'Search All Years',
    loading_year: 'Loading {year} data...',
    more_years: 'More Years',
    show_stats: 'Show Statistics',
    hide_stats: 'Hide Statistics',
    severity: {
      critical: 'CRITICAL',
      high: 'HIGH',
      medium: 'MEDIUM',
      low: 'LOW',
      unknown: 'UNKNOWN',
    },
    status: {
      published: 'PUBLISHED',
      rejected: 'REJECTED',
      modified: 'MODIFIED',
      analyzed: 'ANALYZED',
      waiting: 'WAITING',
      unknown: 'UNKNOWN',
    },
    cpe: {
      vendor: 'Vendor',
      product: 'Product',
      version: 'Version',
      affected_versions: 'Affected Versions',
    },
  },
  ransomware: {
    title: 'Ransomware Attacks',
    description: 'Stay informed about the latest ransomware attacks and protect your data.',
    subtitle: 'Track and monitor the latest ransomware attacks across different countries and sectors',
    countryFilter: 'Country Filter',
    searchPlaceholder: 'Search attacks...',
    showFilter: 'Show Filters',
    details: 'View Details',
    close: 'Close',
    noSearchResults: 'No ransomware attacks found',
    resetFilters: 'Reset Filters',
    filterInstructions: 'Select countries to filter the attacks',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    other: 'Other',
    hideFilter: 'Hide Filters',
    searchResults: '{count} results found',
    noFilteredResults: 'No attacks match your current filters',
    showingCountries: 'Showing attacks from {count} countries',
    loading: 'Loading ransomware data...',
    showingResultsFor: 'Showing results for',
    no_attacks_recorded: 'No ransomware attacks recorded',
    top_targets: 'Top Targets',
    attacks: 'Attacks',
    victims: 'Victims',
  },
  eol: {
    title: 'End of Life Software',
    subtitle: 'Track software that has reached its end-of-life and may pose a security risk',
    description: 'Track software that has reached its end-of-life and may pose a security risk.',
    searchPlaceholder: 'Search software...',
    details: 'View Details',
    daysRemaining: 'Days Remaining',
    expired: 'Expired',
    lts: 'LTS',
    no: 'No',
    latestReleaseDate: 'Latest Release Date',
    releaseDate: 'Release Date',
    eolDate: 'EOL Date',
    latestVersion: 'Latest Version',
    pageTitle: 'End of Life Software Tracker',
    all: 'All',
    sortName: 'Sort by Name',
    clearFilters: 'Clear Filters',
    loading: 'Loading EOL data...',
    version: 'Version',
    sortEOL: 'Sort by EOL Date',
    searchResults: '{count} results found',
    statusActive: 'Active',
    statusWarning: 'Warning',
    statusExpired: 'Expired',
  },
  themeToggle: {
    light: 'Light',
    dark: 'Dark',
    system: 'System',
  },
  languageToggle: {
    pl: 'Polish',
    en: 'English',
    change: 'Change language',
  },
  footer: {
    made_by: 'Made by',
    source_code: 'Source code',
    rights: 'All rights reserved',
  },
  releases: {
    title: 'Software Releases',
    description: 'Track the newest software releases and updates from your favorite projects.',
    search_placeholder: 'Search for projects...',
    clear_search: 'Clear search',
    searching: 'Searching...',
    search_results: '{count} results found',
    no_results: 'No projects found matching your search criteria',
    no_data: 'No release data available',
    error_title: 'Could not load releases data',
    error_description: 'There was an error loading the releases data. Please try again later.',
    error_toast: 'Failed to load releases data',
    github_repository: 'Github Repository',
    pageTitle: 'Latest Software Releases',
    release_date: 'Released',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Key cybersecurity metrics and statistics from the last {days} days',
    pageTitle: 'Cybersecurity Dashboard',
    description: 'View key cybersecurity metrics and statistics from the last 30 days',
    ending_support: 'Ending Support',
    data_leaks: 'Data Leaks',
    active_group: 'Most Active Ransomware Group',
    ransomware_victims: 'Ransomware Victims',
    critical_vulnerabilities: 'Critical Vulnerabilities',
    high_vulnerabilities: 'High Vulnerabilities',
    medium_vulnerabilities: 'Medium Vulnerabilities',
    low_vulnerabilities: 'Low Vulnerabilities',
    last_days: 'Last {days} days',
    most_attacked_country: 'Most Attacked Country',
    latest_news: 'Latest News',
    recent_leaks: 'Recent Data Breaches',
    critical_vulnerabilities_recent: 'Recent Critical Vulnerabilities',
    upcoming_eol: 'Upcoming End of Life',
    latest_releases: 'Latest Releases',
    latest_ransomware: 'Latest Ransomware Attacks',
    ransomware_recent: 'Latest Ransomware Attacks', // Keep this for backward compatibility
    global_ransomware_activity: 'Global Ransomware Activity',
  },
  scan: {
    title: 'Passive Reconnaissance',
    subtitle: 'Analyze a domain without alerting the target. Gathers data from public records, DNS, archives, and threat intelligence feeds.',
    input_placeholder: 'Enter domain to scan...',
    button_scan: 'Start Passive Scan',
    button_scanning: 'Scanning...',
    started: 'Scan started',
    recent_scans: 'Recent Scans',
    no_data: 'No scan results yet. Enter a domain to start.',
    error_domain: 'Please enter a valid domain',
    loading_analyzing: 'Analyzing Target...',
    map_title: 'Active Monitoring Nodes',
    score: 'Score',
    server_location: 'Server Location',
    user_agent: 'Scanner User Agent',
    review_reputation: 'Review Reputation on VirusTotal',
    live_intelligence: 'Live Intelligence',
    preview_unavailable: 'Preview Unavailable',
    comprehensive_results: 'Comprehensive Scan Results',
    missing: 'Missing',
    present: 'Present',
    expires: 'Expires',
    created: 'Created',
    domain_age: 'Domain Age',
    latest_snapshot: 'Latest Snapshot',
    view_snapshot: 'View Snapshot',
    no_snapshots: 'No historical snapshots were found for this URL in the Wayback Machine.',

    security_headers: 'Security Headers',
    connection_stack: 'Connection Stack Specification',
    protocol: 'Protocol',
    cipher_suite: 'Cipher Suite',
    key_exchange: 'Key Exchange',
    post_quantum: 'POST-QUANTUM READY',
    dns_email_security: 'DNS & Email Security',
    grade: 'Grade',
    address_records: 'Address Records',
    txt_records: 'TXT Records & Policies',
    server_location_title: 'Server & Location',
    infrastructure: 'Infrastructure',
    detected_technologies: 'Detected Technologies',
    configuration: 'Configuration',
    common_name: 'Common Name (CN)',
    issuer_org: 'Issuer Organization',
    validity: 'Validity',
    days: 'Days',
    protocol_status: 'Protocol / Status',
    transparency_note: 'Note: Data sourced from Certificate Transparency Logs (Passive).',

    // New keys
    server: 'Server',
    unknown: 'Unknown',
    n_a: 'N/A',
    domain: 'Domain',
    no_signatures: 'No specific signatures found.',
    no_open_ports: 'No open ports found',
    no_subdomains_transparency: 'No subdomains found in transparency logs.',
    none: 'None',
    not_archived: 'Not Archived',
    header_hidden: 'Hidden',
    standard_undetected: 'Standard / Undetected',
    rdap_limited: 'RDAP not available for this TLD. Limited data.',
    no_txt_records: 'No TXT records found.',


    status_transfer_prohibited: 'Status: client transfer prohibited',
    internet_archive: 'Internet Archive',
    archived_found: 'Archived Copy Found',
    archive_seen: 'Archive.org has seen this site since {year} (approx).',
    source: 'Source',
    registrar: 'Registrar',
    status_label: 'Status',
    client_transfer_prohibited: 'client transfer prohibited',
    safebrowsing_title: 'Google Safe Browsing',
    shodan_title: 'Shodan InternetDB',
    abuseipdb_title: 'AbuseIPDB Reputation',
    urlhaus_title: 'URLhaus Malware Database',
    open_ports: 'Open Ports',
    vulnerabilities_title: 'Known Vulnerabilities',
    hostnames: 'Hostnames',
    abuse_score: 'Abuse Score',
    clean: 'No Malware Found',
    urlhaus_clean_desc: 'This host is not listed in URLhaus.',
    malicious_detected: 'Malicious URLs Found',
    virustotal_title: 'VirusTotal Analysis',
    harmless: 'Harmless',
    malicious: 'Malicious',
    suspicious: 'Suspicious',
    undetected: 'Undetected',
    reputation: 'Reputation',
    categories: 'Categories',
    last_analysis_date: 'Last Analysis Date',
    view_full_report: 'View Full Report on VirusTotal',
    setup_required: 'Setup Required',
    add_key_to_env: 'Add {key} to .env',
    subdomains_title: 'Discovered Subdomains',
    discovered_subdomains: 'Unique Subdomains Found',
    link_appears_safe: 'This link appears safe',
    no_threats_detected: 'No threats detected by security scanners',
    link_suspicious: 'This link may be suspicious',

    // AbuseIPDB translations
    last_reported: 'Last reported',
    reports: 'Reports',
    whitelist: 'Whitelist',

    // Safe Browsing translations
    safe_to_visit: 'Safe to visit',
    no_threats_found: 'Google Safe Browsing did not find any threats',
    unsafe_website: 'Unsafe Website Detected!',
    flagged_by_google: 'This site is flagged by Google',
    threat_details: 'Threat Details',

    // Shodan translations
    no_known_vulnerabilities: 'No known vulnerabilities reported',

    // WhatCMS Technology Detection
    technology_detection: 'Technology Detection',
    cms_detected: 'CMS Detected',
    programming_language: 'Programming Language',
    database: 'Database',
    web_server: 'Web Server',
    wordpress_theme: 'WordPress Theme',
    hosting_provider: 'Hosting Provider',
    social_profiles: 'Social Profiles',
    landing_page_builder: 'Landing Page Builder',
    no_technologies_detected: 'No technologies detected',
    theme_name: 'Theme Name',
    theme_author: 'Author',
    theme_version: 'Version',
    host_isp: 'ISP',
    ip_addresses: 'IP Addresses',
    some_warnings: 'Some security scanners flagged potential issues',
    link_dangerous: 'This link is potentially dangerous',
    threats_detected: 'Security scanners detected threats',
    analyzing: 'Analyzing...',
    gathering_data: 'Gathering security data',
    passed: 'passed',
    warnings: 'warnings',
    threats: 'threats',
    threat_intelligence: 'Threat Intelligence',
    reputation_malware: 'Reputation & Malware',
    server_network: 'Server & Network',
    location_ports: 'Location & Ports',
    technical_details: 'Technical Details',
  },
  hibp: {
    email_checker_title: 'Email Breach Checker',
    email_checker_desc: 'Check if your email appeared in any data breaches',
    password_checker_title: 'Password Breach Checker',
    password_checker_desc: 'Check if your password was exposed in data breaches',
    password_generator_title: 'Password Generator',
    password_generator_desc: 'Generate strong, secure passwords',
    enter_email: 'your.email@example.com',
    enter_password: 'Enter password to check',
    check: 'Check',
    generate: 'Generate Password',
    invalid_email: 'Please enter a valid email address',
    api_key_missing: 'HIBP API key not configured',
    check_failed: 'Check failed',
    no_breaches_found: 'No breaches found!',
    email_not_in_database: 'This email was not found in any known data breaches.',
    breaches_found: 'Found in {count} breaches',
    change_passwords_recommendation: 'Consider changing passwords for affected accounts',
    accounts: 'accounts',
    password_safe: 'Password not found in breaches',
    password_safe_desc: 'This password has not appeared in known data breaches',
    password_compromised: 'Found in {count} breaches',
    change_password_now: 'This password is compromised. Change it immediately!',
    security_note: 'Secure: Your password is never sent to our servers. We use k-anonymity to protect your privacy.',
    password_copied: 'Password copied to clipboard',
    password_length: 'Password Length',
    character_types: 'Character Types',
    lowercase: 'Lowercase (a-z)',
    uppercase: 'Uppercase (A-Z)',
    numbers: 'Numbers (0-9)',
    special: 'Special (!@#$...)',
    recommended_settings: 'Recommended: 14+ characters with all character types',
    security_tools: 'Security Tools',
    security_tools_desc: 'Check the security of your email and passwords',
    password_strength: 'Strength',
  },
};
